import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";

export const EASE = [0.16, 1, 0.3, 1];

export const FadeUp = ({ children, delay = 0, className = "", y = 30 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, subtitle, align = "center", light = false }) => (
  <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : "text-left"}`}>
    <FadeUp>
      <p className={`eyebrow ${light ? "text-federasol-blush" : ""}`}>{eyebrow}</p>
      <h2 className={`mt-4 font-serif text-3xl font-medium leading-tight sm:text-4xl lg:text-5xl ${light ? "text-federasol-cream" : "text-federasol-cocoa"}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-5 text-base leading-relaxed ${light ? "text-federasol-cream/85" : "text-federasol-muted"}`}>
          {subtitle}
        </p>
      )}
    </FadeUp>
  </div>
);

export const WhatsAppIcon = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.297-.497.1-.198.05-.371-.025-.52-.074-.149-.668-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
  </svg>
);

export const LogoMark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <circle cx="32" cy="25" r="9.5" fill="#D98F9E" />
    <path
      d="M13 40c3.5-4.5 8.5-4.5 12 0s8.5 4.5 12 0 8.5-4.5 12 0"
      fill="none"
      stroke="#A65D47"
      strokeWidth="3.2"
      strokeLinecap="round"
    />
    <path
      d="M17 50c3-3.8 7-3.8 10 0s7 3.8 10 0 7-3.8 10 0"
      fill="none"
      stroke="#D98F9E"
      strokeWidth="2.6"
      strokeLinecap="round"
      opacity="0.75"
    />
  </svg>
);

export const Logo = ({ onClick, className = "h-14 md:h-16" }) => (
  <a
    href="#inicio"
    onClick={onClick}
    data-testid="header-logo"
    className="flex shrink-0 items-center"
    aria-label="Hotel Federasol - Inicio"
  >
    <img
      src="/logo-federasol.png"
      alt="Hotel Federasol"
      width="720"
      height="416"
      className={`w-auto logo-blend ${className}`}
    />
  </a>
);

export const IllustrativeBadge = () => {
  const { T } = useLang();
  return <span className="ilustrativa-badge">{T.badge}</span>;
};
